import type { EpisodeOfCare, Reference } from "@medplum/fhirtypes";
import { CASE_ENTITY_ID_SYSTEM } from "@repo/api";

/** Case domain identity carried by a reference, without locator translation. */
export function caseDomainId(reference: Reference | undefined): string {
  if (reference?.identifier?.system === CASE_ENTITY_ID_SYSTEM && reference.identifier.value) {
    return reference.identifier.value;
  }
  return "";
}

/** Identifier-only Case reference for optimistic rows; the server mapper supplies the locator. */
export function optimisticCaseReference(caseId: string): Reference<EpisodeOfCare> {
  return { identifier: { system: CASE_ENTITY_ID_SYSTEM, value: caseId } };
}
